import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import pdf_img from "../../images/pdf_image.png"

function BlacklistPopUp({ onclose, onSubmit }) {
    const [reason, setReason] = useState("");
    const [details, setDetails] = useState("");
    const [notes, setNotes] = useState("");
    const [MainArray, setMainArray] = useState([])

    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) {
            setSelectedFile(null);
            return;
        }
        const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'];
        if (!validTypes.includes(file.type)) {
            toast.warn("Only PNG, JPEG, JPG, or PDF files are allowed.", { containerId: "F" });
            return;
        }
        if (file.size < 10000 || file.size > 5000000) {
            toast.warn("File size must be greater than 10KB and less than 5MB.", { containerId: "F" });
            return;
        }
        setSelectedFile(file);
    };

    const [selectedFile1, setSelectedFile1] = useState(null);
    const handleFileChange1 = (e) => {
        const file = e.target.files[0];
        if (!file) {
            setSelectedFile1(null);
            return;
        }
        const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'];
        if (!validTypes.includes(file.type)) {
            toast.warn("Only PNG, JPEG, JPG, or PDF files are allowed.", { containerId: "F" });
            return;
        }
        if (file.size < 10000 || file.size > 5000000) {
            toast.warn("File size must be greater than 10KB and less than 5MB.", { containerId: "F" });
            return;
        }
        setSelectedFile1(file);
    };


    const [selectedFile3, setSelectedFile3] = useState(null);
    const handleFileChange3 = (e) => {
        const file = e.target.files[0];
        if (!file) {
            setSelectedFile3(null);
            return;
        }
        const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'];
        if (!validTypes.includes(file.type)) {
            toast.warn("Only PNG, JPEG, JPG, or PDF files are allowed.", { containerId: "F" });
            return;
        }
        if (file.size < 10000 || file.size > 5000000) {
            toast.warn("File size must be greater than 10KB and less than 5MB.", { containerId: "F" });
            return;
        }
        setSelectedFile3(file);
    };

    const [selectedFile4, setSelectedFile4] = useState(null);
    const handleFileChange4 = (e) => {
        const file = e.target.files[0];
        if (!file) {
            setSelectedFile4(null);
            return;
        }
        const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'];
        if (!validTypes.includes(file.type)) {
            toast.warn("Only PNG, JPEG, JPG, or PDF files are allowed.", { containerId: "F" });
            return;
        }
        if (file.size < 10000 || file.size > 5000000) {
            toast.warn("File size must be greater than 10KB and less than 5MB.", { containerId: "F" });
            return;
        }
        setSelectedFile4(file);
    };


    const handleSubmit = () => {
        if (selectedFile) {
            const validTypes = ['image/png', 'image/jpeg', 'application/pdf'];
            if (!validTypes.includes(selectedFile.type)) {
                toast.warn("Only PNG and JPEG is allowed.", { containerId: "F" });
                return;
            }

        }
        if (selectedFile1) {
            const validTypes = ['image/png', 'image/jpeg', 'application/pdf'];
            if (!validTypes.includes(selectedFile1.type)) {
                toast.warn("Only PNG and JPEG is allowed.", { containerId: "F" });
                return;
            }

        }
        if (selectedFile3) {
            const validTypes = ['image/png', 'image/jpeg', 'application/pdf'];
            if (!validTypes.includes(selectedFile3.type)) {
                toast.warn("Only PNG and JPEG is allowed.", { containerId: "F" });
                return;
            }


        }
        if (selectedFile4) {
            const validTypes = ['image/png', 'image/jpeg', 'application/pdf'];
            if (!validTypes.includes(selectedFile4.type)) {
                toast.warn("Only PNG and JPEG is allowed.", { containerId: "F" });
                return;
            }

        }
        if (!reason) {
            // toast.warn("Start Date is required.");
            toast.warn("Reason is required.", { containerId: "F" });
            return;
        }
        if (!details) {
            toast.warn("Reason Details is required.", { containerId: "F" });
            return;
        }
        if (!notes) {
            toast.warn("Notes  is required.", { containerId: "F" });
        }

        const reasonData = [
            {
                reason: reason,
                reason_details: details,
                doc_attach1: selectedFile,
                doc_attach2: selectedFile1,
                doc_attach3: selectedFile3,
                doc_attach4: selectedFile4,
                notes: notes
            }
        ];
        setMainArray(reasonData)
        console.log(reasonData, "reasonData");
        onSubmit(reasonData);
        onclose();
    };

    return (
        <div>
            <ToastContainer
                enableMultiContainer
                containerId={"F"}
                position="bottom-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
            <div className="modal_parent">
                <div className="module_popup addPeople bfAddPeople">
                    <div className="module_innerpopup module_bodypop">
                        <div className="module_headdiv">
                            <h4 className="popup_head mb-2">Reason</h4>
                        </div>
                        <div className="module_body" style={{ overflowX: "hidden" }}>
                            <div className="row  mb-0 mb-md-3">
                                <div class="form-group col-md-6 mb-md-0 mb-3">
                                    <label htmlFor="" className="form-label">
                                        Reason : <span className="text-danger">*</span>{" "}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Reason"
                                        value={reason}
                                        onChange={(event) => setReason(event.target.value)}
                                    />
                                </div>
                                <div class="form-group col-md-6 mb-md-0 mb-3">
                                    <label htmlFor="" className="form-label">
                                        Details: <span className="text-danger">*</span>{" "}
                                    </label>
                                    <textarea
                                        className="form-control textarea"
                                        placeholder="Enter Details"
                                        rows="1"
                                        value={details}
                                        onChange={(e) => setDetails(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-6 mb-4 d-flex flex-coulmn">
                                            <div className="form-group mb-0">
                                                <label className="form-label">Attach 1</label>
                                                <span className="browse-files mx-2">
                                                    <input type="file" onChange={handleFileChange} />
                                                </span>
                                                {selectedFile && (
                                                    <span className="d-flex flex-column my-2">
                                                        {selectedFile.type === "application/pdf" ? (
                                                            <img
                                                                src={pdf_img}
                                                                width="200"
                                                                alt="pdf-icon"
                                                                className="img-fluid img-upload"
                                                            />
                                                        ) : (
                                                            <img
                                                                src={URL.createObjectURL(selectedFile)}
                                                                width="200"
                                                                alt="profile-img"
                                                                className="img-fluid img-upload"
                                                            />
                                                        )}
                                                    </span>
                                                )}

                                            </div>
                                        </div>

                                        <div className="col-md-6 mb-4">
                                            <div className="form-group mb-0">
                                                <label className="form-label">Attach 2</label>
                                                <span className="browse-files mx-2">
                                                    <input type="file" onChange={handleFileChange1} />
                                                </span>
                                                {selectedFile1 && (
                                                    <span className="d-flex flex-column my-2">
                                                        {selectedFile1.type === "application/pdf" ? (
                                                            <img
                                                                src={pdf_img}
                                                                width="200"
                                                                alt="pdf-icon"
                                                                className="img-fluid img-upload"
                                                            />
                                                        ) : (
                                                            <img
                                                                src={URL.createObjectURL(selectedFile1)}
                                                                width="200"
                                                                alt="profile-img"
                                                                className="img-fluid img-upload"
                                                            />
                                                        )}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-6 mb-4 d-flex flex-coulmn">
                                            <div className="form-group mb-0">
                                                <label className="form-label">Attach 3</label>
                                                <span className="browse-files mx-2">
                                                    <input type="file" onChange={handleFileChange3} />
                                                </span>
                                                {selectedFile3 && (
                                                    <span className="d-flex flex-column my-2">
                                                        {selectedFile3.type === "application/pdf" ? (
                                                            <img
                                                                src={pdf_img}
                                                                width="200"
                                                                alt="pdf-icon"
                                                                className="img-fluid img-upload"
                                                            />
                                                        ) : (
                                                            <img
                                                                src={URL.createObjectURL(selectedFile3)}
                                                                width="200"
                                                                alt="profile-img"
                                                                className="img-fluid img-upload"
                                                            />
                                                        )}
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-md-6 mb-4">
                                            <div className="form-group mb-0">
                                                <label className="form-label">Attach 4</label>
                                                <span className="browse-files mx-2">
                                                    <input type="file" onChange={handleFileChange4} />
                                                </span>
                                                {selectedFile4 && (
                                                    <span className="d-flex flex-column my-2">
                                                        {selectedFile4.type === "application/pdf" ? (
                                                            <img
                                                                src={pdf_img}
                                                                width="200"
                                                                alt="pdf-icon"
                                                                className="img-fluid img-upload"
                                                            />
                                                        ) : (
                                                            <img
                                                                src={URL.createObjectURL(selectedFile4)}
                                                                width="200"
                                                                alt="profile-img"
                                                                className="img-fluid img-upload"
                                                            />
                                                        )}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group col-md-12 mb-md-0 mb-3">
                                <label htmlFor="" className="form-label">
                                    Note: <span className="text-danger">*</span>{" "}
                                </label>
                                <textarea
                                    className="form-control textarea"
                                    placeholder="Enter Note"
                                    
                                    value={notes}
                                    style={{ minHeight: '80px', resize: 'vertical' }}
                                    onChange={(e) =>
                                        e.target.value.length < 500 && setNotes(e.target.value)
                                    }
                                />

                            </div>
                        </div>

                        <div className="childIssueses my-2">
                            <button className="btn-btn btn btn-btn2 btn-sm me-2" onClick={handleSubmit}>Save</button>

                            <button
                                className="btn-btn btn btn-btn1 btn-sm"
                                onClick={() => {
                                    onclose();
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BlacklistPopUp;